import { HttpClient } from '@/services/http-client';
import { RequestWrappers } from '@/services/request-wrappers';

export class BaseRequestsService {

  http = new HttpClient([
    RequestWrappers.baseUrl,
    RequestWrappers.token,
  ]);

}
